"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var InputFocusDirective = (function () {
    function InputFocusDirective(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    InputFocusDirective.prototype.ngAfterViewInit = function () {
        this.renderer.invokeElementMethod(this.el.nativeElement, "focus", []);
        var len = this.el.nativeElement.value.length;
        this.el.nativeElement.setSelectionRange(len, len);
    };
    return InputFocusDirective;
}());
InputFocusDirective = __decorate([
    core_1.Directive({
        selector: "[inputFocus]"
    }),
    __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer])
], InputFocusDirective);
exports.InputFocusDirective = InputFocusDirective;



//////////////////
// WEBPACK FOOTER
// ./resources/themes/pandax/bobtail/~/mydatepicker/dist/directives/my-date-picker.input.directive.js
// module id = 678
// module chunks = 1